const mergeWith = require('lodash.mergewith');
import { DrgResponseDto } from 'src/contracts/drgResponseDto';
import { DiagnosisCode } from 'src/contracts/diagnosisCode';
import { isEmpty } from 'src/common/arrayUtil';
import { Code } from 'src/contracts/code';

export function getDiagnosesFromCalculationResult(drgResponseDtos: DrgResponseDto[]): DiagnosisCode[] {
  const codes: DiagnosisCode[] = [];
  if (isEmpty(drgResponseDtos)) {
    return codes;
  }

  for( let i=0; i<drgResponseDtos.length; i++) {
    const drgResponse = drgResponseDtos[i];

    if (drgResponse.diagnoses_results) {
      for (let j= 0; j < drgResponse.diagnoses_results.length; j++) {
        const drgDiagnosisFlags = drgResponse.diagnoses_results[j];
        const drgDiagnosisDescription = drgResponse?.diagnoses?.find(dxDesc => dxDesc.value == drgDiagnosisFlags.code);
        const qualityFlags = [];
        if (drgDiagnosisFlags?.hac_flag) {
          qualityFlags.push('HAC');
        }

        if(!codes.some(code => code.code == drgDiagnosisFlags.code)) {
          codes.push({
            code: drgDiagnosisFlags.code,
            description: drgDiagnosisDescription?.medium_description || drgDiagnosisDescription?.short_description,
            pdx: codes.length == 0, // pdx if first in the list
            drgModifier: drgDiagnosisFlags ? drgDiagnosisFlags.mcc_flag ? ['MCC'] : drgDiagnosisFlags.cc_flag ? ['CC'] : []: [],
            present_on_admission: drgDiagnosisFlags && drgDiagnosisFlags.poa,
            id: j,
            quality: qualityFlags,
            risk: drgResponse?.elixhauser_code_results?.find(elix => elix.code == drgDiagnosisFlags.code) ? ['ELIX'] : [],
            action: undefined
          });
        }
      }
    }
  }

  return codes;
}

export function getProceduresFromCalculationResult(drgResponseDtos: DrgResponseDto[]): Code[] {
  const codes: Code[] = [];
  if (isEmpty(drgResponseDtos)) {
    return codes;
  }

  for( let i=0; i<drgResponseDtos.length; i++) {
    const drgResponse = drgResponseDtos[i];

    if (drgResponse.procedures_results) {
      for (let j= 0; j < drgResponse.procedures_results.length; j++) {
        const drgProcedureFlags = drgResponse.procedures_results[j];
        const drgProcedureDescription = drgResponse?.procedures?.find(procDesc => procDesc.value == drgProcedureFlags.code);

        if(!codes.some(code => code.code == drgProcedureFlags.code)) {
          codes.push({
            code: drgProcedureFlags.code,
            description: drgProcedureDescription?.medium_description || drgProcedureDescription?.short_description,
            drgModifier: drgProcedureFlags ? (drgProcedureFlags.or_flag ? ['OR'] : []) : [],
            id: j
          });
        }
      }
    }
  }

  return codes;
}

export function mergeDiagnosisLists(base: DiagnosisCode[], changed: DiagnosisCode[], resequnece = false): DiagnosisCode[] {

  if (isEmpty(base) || isEmpty(changed)) {
    return base;
  }

  let mergedList: DiagnosisCode[] = [];

  if (!resequnece) {
    mergedList = base;
  } else {
    // init the merged list with the reordered codes from resequencing
    // then add any additional codes the user may have added since the last
    // calculate request
    changed.forEach(code => {
      const baseCode = base.find(x => x.code.toLowerCase() == code.code.toLowerCase());
      if (baseCode) {
        mergedList.push(baseCode);
      }
    });

    base.forEach(code => {
      // any codes from the base that aren't in our merged list get added to the end
      if (!mergedList.find(x => x.code.toLowerCase() == code.code.toLowerCase())) {
        mergedList.push(code);
      }
    });
  }

  // first apply updates
  for (let i= 0; i< mergedList.length; i++) {
    const code = mergedList[i];
    if (!code.code) {
      continue;
    }
    const changedCode = changed.find(x => x.code && x.code.toLowerCase() === code.code.toLowerCase());
    if (changedCode) {
      mergedList[i] = mergeDiagnosis(code, changedCode);
    }
  }

  return mergedList;
}

export function mergeDiagnosis(base: DiagnosisCode, changed: DiagnosisCode): DiagnosisCode {

  return mergeWith(base, changed, (objValue: unknown, srcValue: unknown, key: string) => {

    // replace arrays instead of merging
    if (Array.isArray(srcValue)) {
      return srcValue;
      // don't update POA
    } else if (key === 'present_on_admission') {
      return objValue;
    }
  });
}